<template>
  <div class="events-page">
    <transition name="processing-notice">
      <div
        v-if="processingNoticeVisible"
        :class="['processing-notice', `processing-notice--${processingNoticeType}`]"
      >
        <van-icon :name="processingNoticeIcon" class="processing-notice__icon" />
        <span>{{ processingNoticeText }}</span>
      </div>
    </transition>

    <van-nav-bar fixed placeholder class="page-nav" :border="false">
      <template #title>
        <span class="page-title">Events</span>
      </template>
      <template #right>
        <van-icon name="home-o" class="home-icon" @click="$router.push('/Home')" />
      </template>
    </van-nav-bar>

    <div class="page-content">
      <section class="period-card">
        <div class="period-head">
          <div class="period-title">Current period</div>
          <button class="plain-link" @click="$router.push('/GameRecord')">
            Gift History
            <van-icon name="arrow" />
          </button>
        </div>

        <div class="current-period notranslate" translate="no">{{ currentPeriod }}</div>
        <div class="period-status">{{ periodStatusText }}</div>

        <div v-if="time > 0" class="timer-badge">
          <van-count-down format="mm:ss" :time="time" @finish="handleCountdownFinish" />
        </div>

        <div class="period-foot">
          <div class="last-period">
            <span class="notranslate" translate="no">{{ previousExpect }} period</span>
            <div class="result-tags">
              <span
                v-for="tag in currentResultTags"
                :key="tag"
                :class="['result-tag', giftThemeMap[tag]]"
              >
                {{ tag }}
              </span>
            </div>
          </div>

          <button class="plain-link" @click="historyVisible = true">
            Gift Result
            <van-icon name="arrow" />
          </button>
        </div>
      </section>

      <section class="gift-card">
        <div class="section-title">
          <span class="title-line"></span>
          <span>Select Gift</span>
        </div>

        <div class="gift-grid">
          <button
            v-for="item in giftOptions"
            :key="item.type"
            :class="['gift-item', { active: choose[item.type] }]"
            @click="choosePlay(item.type, item.displayName)"
          >
            <img class="gift-item__logo" :src="item.displayImage" :alt="item.displayName">
            <span v-if="choose[item.type]" class="gift-item__corner">
              <van-icon name="success" />
            </span>
          </button>
        </div>
      </section>

      <section class="selected-card">
        <div class="section-title">
          <span class="title-line"></span>
          <span>Selected</span>
        </div>

        <div class="selected-body">
          <div class="selected-tags">
            <span
              v-for="item in formData"
              :key="`selected-${item.type}`"
              class="selected-tag-chip"
            >
              {{ item.name }}
            </span>
          </div>

          <div class="input-row">
            <label>Gift Points:</label>
            <van-field v-model="money" type="digit" class="points-input notranslate" translate="no" placeholder="Enter multiple" />
          </div>

          <div class="total-row">
            <span>Total Points:</span>
            <strong class="notranslate" translate="no">{{ totalPoints }}</strong>
          </div>

          <div class="action-row">
            <button class="send-btn" @click="doSub">Send Gift</button>
            <button class="reset-btn" @click="allClear">Reset</button>
          </div>
        </div>
      </section>
    </div>

    <button class="support-btn" @click="openSupport">
      <img src="https://m.sincereloves.online/icon/telegram.png" alt="Telegram">
    </button>

    <van-popup v-model="historyVisible" round position="bottom" :style="{ minHeight: '46%' }">
      <div class="history-popup">
        <div class="history-title">Gift Result</div>
        <div v-for="item in historyItems" :key="item.expect" class="history-item">
          <div class="history-expect notranslate" translate="no">{{ item.expect }}</div>
          <div class="history-tags">
            <span
              v-for="tag in item.tags"
              :key="`${item.expect}-${tag}`"
              :class="['result-tag', giftThemeMap[tag]]"
            >
              {{ tag }}
            </span>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
const GIFT_VISUALS = [
  {
    displayName: 'tinder',
    displayImage: 'https://m.sincereloves.online/images/tinder.png',
    theme: 'tinder'
  },
  {
    displayName: 'bumble',
    displayImage: 'https://m.sincereloves.online/images/bumble.png',
    theme: 'bumble'
  },
  {
    displayName: 'hinge',
    displayImage: 'https://m.sincereloves.online/images/hinge.png',
    theme: 'hinge'
  },
  {
    displayName: 'badoo',
    displayImage: 'https://m.sincereloves.online/images/badoo.png',
    theme: 'badoo'
  }
];
const ISSUE_DISPLAY_BASE = 1071619;

var time;

export default {
  data() {
    return {
      choose: {},
      formData: [],
      giftThemeMap: {
        tinder: 'tinder',
        bumble: 'bumble',
        hinge: 'hinge',
        badoo: 'badoo'
      },
      historyVisible: false,
      lottery: {},
      issueInfo: {},
      lottery_list: [],
      lottery_peilv_list: [],
      money: '10',
      userInfo: {},
      ids: 11,
      keys: 5,
      time: 0,
      size: '',
      double: '',
      rose: 'tinder',
      lily: 'bumble',
      fireworks: 'hinge',
      balloon: 'badoo',
      userTimer: '',
      issueTimer: '',
      issuePollingTimer: '',
      processingNoticeVisible: false,
      processingNoticeText: '',
      processingNoticeType: 'processing',
      processingNoticeAutoHideTimer: ''
    };
  },
  computed: {
    giftOptions() {
      return this.lottery_peilv_list.map((item, index) => ({
        ...item,
        displayName: item.displayName || item.name,
        displayImage: item.displayImage || GIFT_VISUALS[index % GIFT_VISUALS.length].displayImage
      }));
    },
    currentPeriod() {
      return this.formatIssueDisplay(this.issueInfo.current_issue_no || this.lottery.now_expect || '--');
    },
    historyItems() {
      const currentIssueNo = Number(this.issueInfo.current_issue_no || this.lottery.now_expect || 0);
      return this.lottery_list
        .filter((item) => {
          const expect = Number(item && item.expect ? item.expect : 0);
          return !currentIssueNo || (expect > 0 && expect < currentIssueNo);
        })
        .slice(0, 10)
        .map((item) => ({
          expect: this.formatIssueDisplay(item.expect),
          rawExpect: String(item.expect || ''),
          tags: this.getResultTags(item.opencode)
        }));
    },
    previousExpect() {
      if (this.historyItems.length > 0) {
        return this.historyItems[0].expect;
      }
      return this.formatIssueDisplay(this.issueInfo.prev_issue_no || this.lottery.now_expect || '--');
    },
    currentResultTags() {
      if (this.historyItems.length > 0) {
        return this.historyItems[0].tags;
      }
      if (this.issueInfo.prev_result) {
        return this.mapIssueResultToTags(this.issueInfo.prev_result);
      }
      return this.getResultTags(this.lottery.opencode);
    },
    periodStatusText() {
      if (Number(this.issueInfo.stop_remain_sec) > 0) {
        return 'Sending Gift...';
      }
      if (Number(this.issueInfo.over_remain_sec) > 0) {
        return 'Has expired';
      }
      return 'Sending Gift...';
    },
    processingNoticeIcon() {
      return this.processingNoticeType === 'success' ? 'passed' : 'warning-o';
    },
    selectedGiftCount() {
      return Object.keys(this.choose || {}).filter((key) => this.choose[key]).length;
    },
    totalPoints() {
      const unit = Number(this.money) || 0;
      return String(unit * this.selectedGiftCount);
    },
    formattedHistory() {
      return this.historyItems;
    }
  },
  mounted() {
    if (this.userTimer) {
      clearInterval(this.userTimer);
    }

    this.userTimer = setInterval(() => {
      this.getUserInfo();
    }, 10000);
  },
  methods: {
    clearIssueTimers() {
      if (this.issueTimer) {
        clearTimeout(this.issueTimer);
        this.issueTimer = '';
      }
      if (this.issuePollingTimer) {
        clearInterval(this.issuePollingTimer);
        this.issuePollingTimer = '';
      }
      if (this.processingNoticeAutoHideTimer) {
        clearTimeout(this.processingNoticeAutoHideTimer);
        this.processingNoticeAutoHideTimer = '';
      }
    },
    normalizeOpencode(opencode) {
      if (Array.isArray(opencode)) {
        return opencode.slice(0, 3).map((value) => Number(value) || 0);
      }

      if (typeof opencode === 'string' && opencode.trim()) {
        return opencode
          .split(/[,|]/)
          .slice(0, 3)
          .map((value) => Number(value) || 0);
      }

      return [0, 0, 0];
    },
    mapIssueResultToTags(result) {
      const giftMap = {
        '1': this.rose,
        '2': this.lily,
        '3': this.fireworks,
        '4': this.balloon
      };

      return String(result || '')
        .split(',')
        .map((item) => giftMap[item])
        .filter(Boolean);
    },
    mapOpencodeToEventTypes(opencode) {
      const numbers = this.normalizeOpencode(opencode);
      const total = numbers.reduce((sum, value) => sum + (Number(value) || 0), 0);
      const sizeType = total >= 11 && total <= 18 ? 'big' : 'small';
      const parityType = total % 2 === 0 ? 'two' : 'one';

      return [sizeType, parityType];
    },
    mapTypeToGiftName(type) {
      const typeMap = {
        big: this.rose,
        small: this.lily,
        one: this.fireworks,
        two: this.balloon
      };

      return typeMap[type] || '';
    },
    formatIssueDisplay(issueNo) {
      const raw = String(issueNo || '').trim();
      if (!raw) {
        return '--';
      }
      if (/^\d{1,7}$/.test(raw)) {
        return raw;
      }
      if (/^\d{10,}$/.test(raw)) {
        const sequence = parseInt(raw.slice(9), 10);
        if (!Number.isNaN(sequence)) {
          return String(ISSUE_DISPLAY_BASE + sequence);
        }
      }
      return raw;
    },
    getResultTags(opencode) {
      return this.mapOpencodeToEventTypes(opencode)
        .map((type) => this.mapTypeToGiftName(type))
        .filter(Boolean);
    },
    openSupport() {
      const service = this.$store.getters.getBaseInfo || {};
      if (service.iskefu == 1 && service.kefu) {
        window.location.href = service.kefu;
        return;
      }
      this.$router.push('/ServiceOnline');
    },
    choosePlay(type, name) {
      if (this.choose[type]) {
        this.choose[type] = false;
        this.formData = this.formData.filter((item) => item.type !== type);
        return;
      }

      this.$set(this.choose, type, true);
      this.formData.push({ name, type });
    },
    allClear() {
      this.formData.forEach((item) => {
        this.$set(this.choose, item.type, false);
      });
      this.formData = [];
      this.money = '10';
    },
    scheduleIssueRefresh(delay = 1000) {
      if (this.issueTimer) {
        clearTimeout(this.issueTimer);
      }
      this.issueTimer = setTimeout(() => {
        this.getLotteryIssueNo(false);
      }, delay);
    },
    handleCountdownFinish() {
      this.startIssuePolling();
    },
    startIssuePolling() {
      if (this.issuePollingTimer) {
        return;
      }

      const currentIssue = this.issueInfo.current_issue_no;
      this.issuePollingTimer = setInterval(() => {
        this.getLotteryIssueNo(false, currentIssue);
      }, 1000);
    },
    stopIssuePolling() {
      if (this.issuePollingTimer) {
        clearInterval(this.issuePollingTimer);
        this.issuePollingTimer = '';
      }
    },
    showProcessingNotice(issueNo) {
      this.processingNoticeText = `${this.formatIssueDisplay(issueNo || this.currentPeriod || '--')} Participating in activity...`;
      this.processingNoticeType = 'processing';
      this.processingNoticeVisible = true;
    },
    showSuccessNotice(issueNo) {
      this.processingNoticeText = `${this.formatIssueDisplay(issueNo || this.currentPeriod || '--')} Activity participation successful`;
      this.processingNoticeType = 'success';
      this.processingNoticeVisible = true;
      if (this.processingNoticeAutoHideTimer) {
        clearTimeout(this.processingNoticeAutoHideTimer);
      }
      this.processingNoticeAutoHideTimer = setTimeout(() => {
        this.hideProcessingNotice();
      }, 2600);
    },
    hideProcessingNotice() {
      if (this.processingNoticeAutoHideTimer) {
        clearTimeout(this.processingNoticeAutoHideTimer);
        this.processingNoticeAutoHideTimer = '';
      }
      this.processingNoticeVisible = false;
      this.processingNoticeText = '';
    },
    doSub() {
      if (this.money === '0' || this.money === '') {
        this.$toast('Please enter points');
        return false;
      }

      if (this.formData.length === 0) {
        this.$toast('Please select a gift');
        return false;
      }

      if (Number(this.userInfo.money || 0) - Number(this.totalPoints) < 0) {
        this.$toast('Insufficient balance, please recharge first');
        return false;
      }

      this.$http({
        method: 'post',
        data: {
          item: this.formData.map((item) => item.type).join(','),
          money: this.money,
          lid: this.lottery.id,
          mid: this.userInfo.id,
          expect: this.lottery.now_expect
        },
        url: 'game_place_order'
      }).then((res) => {
        if (res.code === 200) {
          this.$toast(res.msg || 'Sent successfully');
          this.allClear();
          this.getUserInfo();
          this.getLotteryIssueNo(true);
          this.getLotteryList();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });

      return true;
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data || {};
          if (this.userInfo.is_online != 1) {
            localStorage.clear();
            this.$router.push({ path: '/Login' });
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getLotteryIssueNo(showError = true, previousIssue = '') {
      this.$http({
        method: 'get',
        data: { key: this.keys },
        url: 'lottery_issue_no'
      }).then((res) => {
        if (res.code === 200) {
          const issueData = res && res.data && typeof res.data === 'object' ? res.data : {};
          const changed = previousIssue && issueData.current_issue_no && issueData.current_issue_no !== previousIssue;

          this.issueInfo = issueData;
          this.lottery = {
            ...this.lottery,
            now_expect: issueData.current_issue_no || this.lottery.now_expect
          };

          const stopRemain = Number(issueData.stop_remain_sec || 0);
          const overRemain = Number(issueData.over_remain_sec || 0);
          this.time = stopRemain > 0 ? stopRemain * 1000 : 0;

          if (changed) {
            this.stopIssuePolling();
            this.showSuccessNotice(previousIssue || issueData.prev_issue_no || issueData.current_issue_no);
            this.getLotteryList();
          } else if (stopRemain <= 0 && overRemain > 0) {
            this.showProcessingNotice(issueData.current_issue_no);
            this.startIssuePolling();
          } else {
            this.stopIssuePolling();
            this.hideProcessingNotice();
            this.scheduleIssueRefresh(Math.min(Math.max(stopRemain, 5), 30) * 1000);
          }
        } else if (res.code === 401 && showError) {
          this.$toast(res.msg);
        }
      }).catch(() => {
        if (showError) {
          this.$toast('Failed to load lottery information');
        }
      });
    },
    getLotteryPeilv() {
      this.$http({
        method: 'get',
        data: { id: this.ids },
        url: 'lottery_get_peilv'
      }).then((res) => {
        if (res.code === 200) {
          const list = Array.isArray(res.data) ? res.data : [];
          this.lottery_peilv_list = list.slice(0, 4).map((item, index) => ({
            ...item,
            displayName: GIFT_VISUALS[index].displayName,
            displayImage: GIFT_VISUALS[index].displayImage,
            theme: GIFT_VISUALS[index].theme
          }));

          this.lottery_peilv_list.forEach((item) => {
            if (typeof this.choose[item.type] !== 'boolean') {
              this.$set(this.choose, item.type, false);
            }
          });
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getLotteryList() {
      this.$http({
        method: 'get',
        data: { key: this.keys },
        url: 'lottery_get_one_list'
      }).then((res) => {
        if (res.code === 200) {
          const list = Array.isArray(res.data) ? res.data : [];
          this.lottery_list = list.map((item) => ({
            ...item,
            opencode: this.normalizeOpencode(item && item.opencode)
          }));
          this.getLotteryPeilv();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getLotteryInfo() {
      this.$http({
        method: 'get',
        data: { key: this.keys },
        url: 'lottery_get_info'
      }).then((res) => {
        if (res.code === 200) {
          const lotteryData = res && res.data && typeof res.data === 'object' ? res.data : {};
          const opencode = this.normalizeOpencode(lotteryData.opencode);

          if (parseFloat(this.userInfo.money || 0) < parseFloat(lotteryData.condition || 0)) {
            this.$toast('Please contact customer service to continue');
            this.$router.push({ path: '/Home' });
            return false;
          }

          this.lottery = {
            ...this.lottery,
            ...lotteryData,
            opencode
          };

          const tags = this.getResultTags(opencode);
          this.size = tags[0];
          this.double = tags[1];
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
      return;
    }

    this.getUserInfo();
    this.getLotteryInfo();
    this.getLotteryIssueNo();
    this.getLotteryList();
  },
  destroyed() {
    clearInterval(time);
    if (this.userTimer) {
      clearInterval(this.userTimer);
      this.userTimer = '';
    }
    this.clearIssueTimers();
  }
};
</script>

<style lang="less" scoped>
.events-page {
  min-height: 100vh;
  background: #000;
  color: #fff;
}

.processing-notice {
  position: fixed;
  top: 18px;
  left: 50%;
  z-index: 2100;
  display: flex;
  width: calc(100% - 36px);
  max-width: 520px;
  align-items: center;
  justify-content: center;
  padding: 18px 22px;
  border-radius: 28px;
  background: rgba(125, 136, 157, 0.96);
  color: #fff;
  font-size: 19px;
  font-weight: 700;
  line-height: 1.25;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.28);
  transform: translateX(-50%);
}

.processing-notice--processing {
  background: rgba(125, 136, 157, 0.96);
}

.processing-notice--success {
  background: linear-gradient(180deg, #10d862, #08c754);
}

.processing-notice__icon {
  margin-right: 12px;
  font-size: 24px;
}

.processing-notice-enter-active,
.processing-notice-leave-active {
  transition: opacity 0.22s ease, transform 0.22s ease;
}

.processing-notice-enter,
.processing-notice-leave-to {
  opacity: 0;
  transform: translate(-50%, -12px);
}

.page-nav {
  min-height: 96px;
  background: #1c1c1e;
}

::v-deep .page-nav .van-nav-bar {
  background: #1c1c1e;
  box-shadow: none;
}

::v-deep .page-nav .van-nav-bar__content {
  height: 96px;
}

.page-title {
  color: #e6b98a;
  font-size: 28px;
  font-weight: 700;
}

.home-icon {
  color: #e6b98a;
  font-size: 34px;
}

.page-content {
  padding: 14px 12px 128px;
}

.period-card,
.gift-card,
.selected-card {
  margin-bottom: 22px;
  padding: 28px 26px;
  border: 1px solid #766350;
  border-radius: 18px;
  background: linear-gradient(180deg, rgba(41, 41, 41, 0.98), rgba(29, 29, 29, 0.96));
}

.period-card {
  background:
    linear-gradient(180deg, rgba(22, 22, 22, 0.26), rgba(22, 22, 22, 0.38)),
    url('https://m.sincereloves.online/images/room_bg.gif') center / cover no-repeat;
}

.period-head,
.period-foot,
.action-row,
.total-row,
.input-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.period-title,
.current-period,
.section-title span:last-child,
.plain-link,
.total-row strong {
  font-weight: 700;
}

.period-title {
  font-size: 34px;
}

.plain-link {
  display: inline-flex;
  align-items: center;
  border: none;
  background: transparent;
  color: #fff;
  font-size: 30px;
}

.plain-link .van-icon {
  margin-left: 10px;
  font-size: 28px;
}

.current-period {
  margin-top: 22px;
  font-size: 46px;
  line-height: 1;
}

.period-status {
  margin-top: 8px;
  margin-left: 0;
  color: rgba(255, 255, 255, 0.9);
  font-size: 30px;
  font-weight: 700;
}

.timer-badge {
  display: inline-flex;
  min-width: 124px;
  margin-top: 22px;
  padding: 12px 18px;
  border: 1px solid rgba(255, 255, 255, 0.65);
  border-radius: 12px;
  background: rgba(22, 22, 22, 0.26);
  font-size: 30px;
  font-weight: 700;
  line-height: 1;
}

::v-deep .timer-badge .van-count-down {
  color: #ffffff;
  font-size: 30px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  line-height: 1;
}

.period-foot {
  margin-top: 28px;
}

.last-period {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  font-size: 28px;
  font-weight: 700;
}

.result-tags {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 14px;
}

.result-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 132px;
  padding: 12px 20px;
  border-radius: 12px;
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  text-transform: lowercase;
}

.result-tag.tinder {
  background: #ff4d8d;
}

.result-tag.bumble {
  background: #dbb74f;
  color: #1f1f1f;
}

.result-tag.hinge {
  background: #ffffff;
  color: #1f1f1f;
}

.result-tag.badoo {
  background: #e91025;
}

.section-title {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  color: #f0be88;
  font-size: 24px;
  font-weight: 700;
}

.title-line {
  width: 6px;
  height: 28px;
  margin-right: 12px;
  background: #e6b98a;
}

.gift-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px 18px;
}

.gift-item {
  position: relative;
  display: flex;
  min-height: 126px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 14px 18px;
  border: 1px solid rgba(214, 73, 134, 0.72);
  border-radius: 16px;
  background: linear-gradient(180deg, rgba(39, 32, 39, 0.95), rgba(31, 28, 33, 0.96));
}

.gift-item.active {
  border-color: #d57b9f;
  box-shadow: 0 0 0 1px rgba(250, 173, 203, 0.24) inset;
  transform: translateY(-1px);
}

.gift-item__logo {
  max-width: 82%;
  max-height: 66px;
  object-fit: contain;
}

.gift-item__corner {
  position: absolute;
  right: 0;
  bottom: 0;
  display: flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, transparent 0 48%, #f3d4aa 48% 100%);
  color: #7b5a35;
  font-size: 18px;
}

.selected-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 22px;
}

.selected-tag-chip {
  display: inline-flex;
  min-width: 96px;
  align-items: center;
  justify-content: center;
  padding: 8px 18px;
  border: 1px solid rgba(191, 136, 78, 0.72);
  border-radius: 999px;
  color: #f2bd7b;
  font-size: 24px;
  line-height: 1;
  background: rgba(38, 34, 32, 0.92);
}

.selected-body {
  padding-top: 12px;
  display: grid;
  gap: 18px;
}

.input-row {
  align-items: center;
  gap: 18px;
}

.input-row label,
.total-row span {
  color: #f0be88;
  font-size: 22px;
  font-weight: 700;
}

.points-input {
  width: 48%;
  border: 1px solid rgba(185, 142, 92, 0.78);
  border-radius: 16px;
  background: linear-gradient(180deg, rgba(52, 52, 56, 0.98), rgba(36, 36, 39, 0.98));
  box-shadow: inset 0 0 0 1px rgba(255, 232, 200, 0.03);
}

::v-deep .points-input .van-field__control {
  color: #d8a268;
  font-size: 28px;
  font-weight: 700;
}

::v-deep .points-input .van-cell {
  padding: 0 18px;
  background: transparent;
}

::v-deep .points-input .van-field__body {
  min-height: 72px;
}

::v-deep .points-input .van-field__control::placeholder {
  color: rgba(216, 162, 104, 0.56);
}

.total-row {
  margin-top: 4px;
  color: #f0be88;
  font-size: 22px;
}

.total-row strong {
  color: #ff4d8d;
  font-size: 28px;
}

.action-row {
  margin-top: 6px;
  gap: 14px;
  align-items: stretch;
}

.send-btn,
.reset-btn {
  flex: 1;
  height: 68px;
  border: none;
  border-radius: 8px;
  font-size: 22px;
  font-weight: 700;
}

.send-btn {
  background: linear-gradient(180deg, #f7dfc2, #dfb07d);
  color: #5f3a13;
  box-shadow: 0 10px 18px rgba(0, 0, 0, 0.18);
}

.reset-btn {
  max-width: 110px;
  background: rgba(126, 126, 126, 0.34);
  color: rgba(255, 255, 255, 0.78);
}

.support-btn {
  position: fixed;
  right: 22px;
  bottom: 142px;
  z-index: 30;
  display: flex;
  width: 96px;
  height: 96px;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: #ff2f34;
  box-shadow: 0 0 18px rgba(255, 66, 87, 0.55);
}

.support-btn img {
  width: 42px;
  height: 42px;
}

.history-popup {
  padding: 24px 20px 34px;
  background: #1c1d22;
  color: #fff;
}

.history-title {
  margin-bottom: 18px;
  font-size: 26px;
  font-weight: 700;
}

.history-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.history-expect {
  font-size: 20px;
}

.history-tags {
  display: inline-flex;
  gap: 8px;
}
</style>
